import { Divider, Flex, Spin, Typography } from "antd"
import { useSelector } from "react-redux"

import Images from "../../../../Images"
import { formatCurrency } from "../../../../Utils/utils"

import "./styles.less"

const { Text } = Typography

const TotalNumbers = () => {
  const { totalStatistics, totalStatisticsFetching } = useSelector((state) => state.referrals)
  const isMobile = useSelector((state) => state.nav.isMobile)
  const {
    total_alerts,
    alerts_earned,
    ethoca_reward_amount,
    verify_reward_amount,
    bonuses_earned
  } = totalStatistics ?? {
    total_alerts: 0,
    alerts_earned: 0,
    ethoca_reward_amount: 0,
    verify_reward_amount: 0,
    bonuses_earned: 0
  }

  return (
    <Spin spinning={totalStatisticsFetching}>
      <Flex gap={12} className="referrals-total-numbers">
        <Flex gap={4} vertical className="referrals-card">
          <Text type="secondary">Total Alerts</Text>
          <Text className="total-number">{total_alerts}</Text>
        </Flex>
        <Flex gap={isMobile ? 2 : 16} className="referrals-card earned-card">
          <Flex gap={4} vertical className="earned-from-alerts">
            <Text type="secondary">Earned from Alerts</Text>
            <Text className="total-number">{formatCurrency(alerts_earned / 100)}</Text>
          </Flex>
          {!isMobile && <div className="divider"></div>}
          {isMobile && <Divider style={{ margin: isMobile && "6px 0" }} />}
          <Flex gap={8} vertical className="commission-per-alert">
            <Text type="secondary">Commission per Alert</Text>
            <Flex gap={20}>
              <Flex gap={8}>
                <img height={20} width={20} src={Images.mastercard} alt=""></img>
                <Text type="secondary">
                  Ethoca: {formatCurrency(ethoca_reward_amount / 100, true)}
                </Text>
              </Flex>
              <Flex gap={8}>
                <img height={20} width={20} src={Images.verifi} alt=""></img>
                <Text type="secondary">
                  Verifi: {formatCurrency(verify_reward_amount / 100, true)}
                </Text>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
        <Flex gap={4} vertical className="referrals-card earned-from-bonuses">
          <Text type="secondary">Earned from Bonuses</Text>
          <Text className="total-number">{formatCurrency(bonuses_earned / 100)}</Text>
        </Flex>
      </Flex>
    </Spin>
  )
}

export default TotalNumbers
